/* eslint-disable @typescript-eslint/naming-convention */
import { dayBriefBlock } from '../../../../ui/organisms/AIMessageBlock/DayBriefRenderer/__fixtures__/dayBriefBlock';
import { mockFieldAgent } from '../agents';
import { mockConversations } from '../conversations';
import { makeStreamStart, makeBlockComplete, makeStreamEnd } from '../sseEvents';
const RESPONSE_ID = 'resp-day-brief';
const CONV_ID = 'conv-1';
// IPA emits the whole brief as ONE atomic day_brief block (contract A8), so the
// sequence has no markdown deltas to stream.
const sseSequence = [
    makeStreamStart(RESPONSE_ID, CONV_ID, mockFieldAgent),
    makeBlockComplete(dayBriefBlock, 100),
    makeStreamEnd(RESPONSE_ID, 1, mockFieldAgent)
];
export const scenario = {
    name: 'Field Assistant — Day Brief',
    description: 'A technician asks to be ready for their day; the Field Assistant answers with one atomic day_brief block rendered as stop cards.',
    conversations: mockConversations,
    userMessage: 'Get me ready for my day',
    agentIdentity: mockFieldAgent,
    sseSequence
};
